import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_ColorField } from '../../../../../../../../design/fields/colorField/S_ColorField';

interface IProps {
  color: string;
  onChangeColor: (color: string) => void;
  isRequired?: boolean;
}

export const ColorField = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_ColorField
      isRequired={props.isRequired}
      labelText={t('projects.details.annotation_tools.marking_tools.color')}
      onChange={props.onChangeColor}
      value={props.color}
    />
  );
});
